export const numberMasking = (phoneNumber) => {
    if (!phoneNumber || typeof phoneNumber !== 'string' && typeof phoneNumber !== 'number') {
        return '';
    }
    const phoneStr = phoneNumber.toString().trim();
    if (phoneStr.length < 10) return phoneStr;
    let masked = phoneStr.split('');
    if (masked[2]) masked[2] = 'X';
    if (masked[5]) masked[5] = 'X';
    if (masked[8]) masked[8] = 'X';

    return masked.join('');
};